export function hasInvoiceEdits(invoice) {
  return Object.values(invoice?.isEdited || {}).some((edited) => edited === true);
}
